module.exports = __webpack_public_path__ + "media/images/icon__warning@2x-41fc9dda8c908784e6c6f89ddb3e9b95.png";